import { HTTP } from "@/utils/http";
import Apis from '@/apis/index';
import EventBus from "@/eventbus";
const _state = {
    isLoadingTrack: false,
    uploadLockedStore: false,
    currentTrack: null,
    tracksBucket: [],
    tracksBucketIndex: 0,
    trackLoadErrors: [],
    playingTrack : null,
    isPlaying : false,
    closeAfterEdit: false,
    prevPage: null,
    isDeletedTrack: false,
    checkLockStation: null,
    countries: [],
};

export default {
    name: 'tracks',
    namespaced: true,
    state: _state,
    mutations: {
        // Events on track load
        onTrackLoading: (state) => { state.isLoadingTrack = true },
        onTrackLoadingError: (state, errors) => state.trackLoadErrors = errors,
        onTrackLoaded: (state, track) => state.currentTrack = track,
        onCountriesLoaded: (state, countries) => state.countries = countries,
        isStationLocked: (state, isLocked) => state.uploadLockedStore = isLocked,
        checkStationLock: (state, uuid) => state.checkLockStation = uuid,
        onTrackLoadCompleted: (state) => state.isLoadingTrack = false,
        onPlayTrack:(state, track) => { state.playingTrack = track; state.isPlaying = true; },
        onPauseTrack:(state, track) => state.isPlaying = false,
        onResetPlayer:(state, track) => {console.log("Reset Player"); state.playingTrack=null; state.isPlaying = false } ,
        next: (state) => {
            state.tracksBucketIndex++;
            // state.currentTrack = state.tracksBucket[state.tracksBucketIndex];
        },
        prev: (state) => {
            state.tracksBucketIndex--;
            // state.currentTrack = state.tracksBucket[state.tracksBucketIndex];
        },
        updateTracks: (state, tracks) => {
            state.tracksBucket = tracks;
            state.tracksBucketIndex = 0;

            if (tracks.length > 0) {
                state.currentTrack = tracks[0];
            }
        },
        updateClose: (state, status) => state.closeAfterEdit = status, 
        updatePrevPage: (state, page) => state.prevPage = page,
        resetState: (state) => {
            state = Object.assign({}, state, _state)
        },
        isDeletedTrack: (state, payload) => {
            state.isDeletedTrack = payload
        }
    },
    actions: {
        isStationLock({ commit }, stationUid) {
            // console.log('++++++++++++++++++++++++++++++++++++++------------------------------------' , _state.checkLockStation);
            // console.log('++++++++++++++++++++++++++++++++++++++------------------------------------' , stationUid);


                try {
                    if (_state.checkLockStation !== stationUid){
                    commit('checkStationLock', stationUid);
                    HTTP.get(Apis.station.lock + "?stationUid="+stationUid).then(
                        (response) => {
                            if (response.data.dataItem != null) {
                                commit('isStationLocked', response.data.dataItem);
                                EventBus.$emit("isStationLockedBus", response.data.dataItem);
                            }
                        },
                        (response) => {
                            // commit('onTrackLoadingError', response.data.errors || { message: "An error occured" });
                        });


                   }
                } catch (e) {
                    console.log("loadTrack -> error:", e);
                }

        },
        loadTrack({ commit }, { stationUid, trackUid }) {
            try {
                if (stationUid && trackUid) {
                    HTTP.get(Apis.library.tracks.details + '/' + trackUid +"?stationUid="+stationUid).then(
                        (response) => {
                            if (response.data.dataItem != null) { commit('onTrackLoaded', response.data.dataItem); }
                        },
                        (response) => {
                            commit('onTrackLoadingError', response.data.errors || { message: "An error occured" });
                        }).then(() => commit("onTrackLoadCompleted"));
                }
                else {
                    commit('onTrackLoadCompleted', null);
                }
            } catch (e) {
                console.log("loadTrack -> error:", e);
            }
        },
        loadCountiesList({ commit }) {
            console.log('loadCountiesList', typeof _state.countries.length)
           // if (_state.countries.length !==0){
                try {
                    HTTP.get('/api/library/chartcountries').then(
                        (response) => {
                            if (response.data.dataItem != null) {
                                commit('onCountriesLoaded', response.data.dataItem.countries);
                            }
                        });

                } catch (e) {
                    console.log("loadTrack -> error:", e);
                }
            }

        // }
    }
};
